//var moment = require('moment');
import moment from 'moment';
import i18n from '../i18n/index.js';
import en from '../i18n/en_US';
import fr from '../i18n/fr_FR';
const TOAST_DURATION = 5000;

export default {
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  mounted() {
    this.$root.$on('setFormLang', lang => {
      this.$i18n.locale = lang;
      i18n.locale = lang;
    });
  },
  methods: {
    watchUndoRemoveItem(array) {
      return new Promise((resolve, reject) => {
        this.$toasted.clear();
        let toast = this.$toasted.show(i18n.t('toast.success_delete'), {
          theme: 'bubble',
          position: 'bottom-right',
          duration: TOAST_DURATION,
          icon: {
            name: 'icon-warning mr-2',
          },
          action: {
            text: i18n.t('button.cancel'),
            onClick: (e, toastObject) => {
              resolve(array);
              toastObject.goAway(0);
            },
          },
        });
        setTimeout(() => {
          reject();
        }, TOAST_DURATION + 1);
      });
    },
    showToast(type, message, icon) {
      let toast = this.$toasted.show(message, {
        type,
        theme: 'bubble',
        position: 'bottom-right',
        duration: TOAST_DURATION,
        icon: {
          name: 'mr-2 ' + icon,
        },
      });
    },
    mapFormData(form) {
      let empLivesForm = JSON.parse(JSON.stringify(form));
      const startDate = moment.utc(empLivesForm.startDate);
      const endDate = moment.utc(empLivesForm.startDate);
      // convert startTime from local to utc time
      const localDate = moment(form.startDate);

      const utcDateTime = moment(empLivesForm.startTime, 'HH:mm');
      const localDateTime = localDate
        .hours(utcDateTime.hours())
        .minutes(utcDateTime.minutes());
      const startTimeDate = localDateTime.utc();
      const startTime = moment(startTimeDate, 'HH:mm');
      empLivesForm.startDate = moment(startTimeDate).format('HH:mm');
      empLivesForm.startTime = moment(startTimeDate).format('HH:mm');
      // convert endTime from local to utc time
      const utcEndTime = moment(empLivesForm.endTime, 'HH:mm');
      const endTimeDate = utcEndTime.utc();
      const endTimeOneHour = moment(endTimeDate, 'HH:mm');
      empLivesForm.endTime = moment(endTimeDate).format('HH:mm');
      empLivesForm.canCommentBeforeLive= empLivesForm.foComment ? empLivesForm.canCommentBeforeLive : false;
      empLivesForm.canReplyToComments= empLivesForm.foComment ? empLivesForm.canReplyToComments : false;
      empLivesForm.isCommentValidation= empLivesForm.foComment ? empLivesForm.isCommentValidation : false;
      empLivesForm.active = empLivesForm.active? true:false;


      startDate.set({
        hour: startTime.get('hour'),
        minute: startTime.get('minute'),
        second: 0,
      });

      empLivesForm.dateStart = startDate.format();
      let endTimeWithDuration = startDate;
      let endTimeWithOneHour = startDate;

      if(empLivesForm.duration){
        const duration = moment(empLivesForm.duration, 'HH:mm');
        endTimeWithDuration.add(duration.get('hour'), 'hours')
                .add(duration.get('minute'), 'minutes').format('LT');
        empLivesForm.dateEnd = endTimeWithDuration.format();
      }else if(window.process.env.ISFM && window.process.env.ISFM !=="false") {
        endTimeWithOneHour.add(endTimeOneHour.get('hour'), 'hours')
          .add(endTimeOneHour.get('minute'), 'minutes').format('LT');

        endDate.set({
          hour: endTimeOneHour.get('hour'),
          minute: endTimeOneHour.get('minute'),
          second: 0,
        });
        empLivesForm.dateEnd = endDate.format();
      }else{
        endDate.set({
          hour: endTimeOneHour.get('hour'),
          minute: endTimeOneHour.get('minute'),
          second: 0,
        });
        empLivesForm.dateEnd = endDate.format();
      }


      empLivesForm.isCdn = empLivesForm.isCdn ? '1' : '0';

      // if (empLivesForm.contributors) {
      //   empLivesForm.contributors = empLivesForm.contributors.map(c => c.id);
      // }

      if (empLivesForm.themes) {
        empLivesForm.themes = empLivesForm.themes.map(c => c.id);
      }

      if (empLivesForm.types) {
        if (Array.isArray(empLivesForm.types)) {
          empLivesForm.types = empLivesForm.types.length && empLivesForm.types[0].id !== 0 
            ? [empLivesForm.types[0].id] 
            : [];
        } else if (typeof empLivesForm.types === 'object' && empLivesForm.types.id !== 0) {
          empLivesForm.types = [empLivesForm.types.id];
        } else {
          empLivesForm.types = [];
        }
      }
      if (empLivesForm.slides) {
        empLivesForm.slides = empLivesForm.slides.map(s => ({
          slide: s.slide,
          slideType: s.slideType,
        }));
      }

      if(empLivesForm.tags)
      empLivesForm.tags = empLivesForm.tags.join(' ');

      empLivesForm.isProtected = !!empLivesForm.pwd;
      empLivesForm.thumbnail = form.thumbnail
      if(empLivesForm.thumbnailPath && !empLivesForm.thumbnail){
        empLivesForm.thumbnail=empLivesForm.thumbnailPath;
      }
      delete empLivesForm.thumbnailPath;
      if (!empLivesForm.pwd) {
        delete empLivesForm.pwd;
      }

      delete empLivesForm.confAfter;
      delete empLivesForm.created_at;
      delete empLivesForm.live;
      //delete empLivesForm.screenType;
      delete empLivesForm.server_infos;
      delete empLivesForm.updated_at;
      delete empLivesForm.urlDiffusion;
      delete empLivesForm.urlPlayer;

      return { id: empLivesForm.id, empLivesForm };
    },
    mapThemes(channels) {
      const _channels = Object.keys(channels).map(k => channels[k]);
      return this.flatten(_channels, 0);
    },
    flatten(arr, index) {
      let newArr = [];
      for (let i = 0; i < arr.length; i++) {
        let item = {
          title: arr[i].title,
          id: arr[i].id,
          $isDisabled: index === 0,
          index: index > 1 ? index - 1 : 0,
        };
        newArr.push(item);
        if (arr[i].themes.length > 0) {
          newArr = newArr.concat(this.flatten(arr[i].themes, index + 1));
        }
      }
      return newArr;
    },
    generatePassword() {
      var length = 8,
        charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789',
        retVal = '';
      for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
      }
      return retVal;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/UtilsMixin.js